export const CONTACT_TITLE_OPTIONS = ["Herr", "Frau", "Familie", "Divers"]
